var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#account-fill_svg__clip0_230_2257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 9a4 4 0 018 0v1a4 4 0 01-8 0V9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.383 5.383 0 12 0s12 5.383 12 12-5.383 12-12 12S0 18.617 0 12zm14 4c2.198 0 4.034 1.431 4.698 3.404C20.72 17.573 22 14.936 22 12c0-5.514-4.486-10-10-10S2 6.486 2 12c0 2.937 1.281 5.574 3.304 7.405C5.968 17.432 7.802 16 10 16h4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "account-fill_svg__clip0_230_2257"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgAccountFill;